
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { cn } from "@/lib/utils";

interface StatCardProps {
  title: string;
  value: string;
  icon?: React.ReactNode;
  iconBg?: string;
  className?: string;
  onClick?: () => void;
}

const StatCard = ({ title, value, icon, iconBg, className, onClick }: StatCardProps) => {
  return (
    <Card
      onClick={onClick}
      className={cn(
        "transition-all hover:shadow-lg",
        onClick && "cursor-pointer",
        className
      )}
    >
      <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
        <CardTitle className="text-sm font-medium">{title}</CardTitle>
        {icon && (
          <div
            className={cn(
              iconBg
                ? `p-3 rounded-full ${iconBg}`
                : 'text-gray-500 dark:text-muted-foreground',
            )}
          >
            {icon}
          </div>
        )}
      </CardHeader>
      <CardContent>
        <div className="text-2xl font-bold">{value}</div>
      </CardContent>
    </Card>
  );
};

export default StatCard;
